function iniciarPaginacao(options) {
  options = options || {};

  var documentClickHandler = null;

  const MAX_VISIBLE_DEFAULT = 5;

  const SEL = {
    root: '.pagination[data-total-pages]',
    list: '#pagination-list',
    popup: '#pagination-popup',
    goInput: '#pagination-go-input',
    goBtn: '#pagination-go-btn',
    goError: '#pagination-go-error',
    prev: '#pagination-prev-page',
    next: '#pagination-next-page',
    perPage: '#pagination-per-page',
  };

  const ARIA = {
    hidden: 'aria-hidden',
    expanded: 'aria-expanded',
    invalid: 'aria-invalid',
    disabled: 'aria-disabled',
  };

  function navigate(page) {
    if (options.onPageChange) {
      options.onPageChange(page);
    } else {
      window.location.href = buildPageUrl(page);
    }
  }

  function parseNumber(value, fallback) {
    const n = parseInt(value, 10);
    return Number.isNaN(n) ? fallback : n;
  }

  function getPageParams(root) {
    const total = parseNumber(root.dataset.totalPages, 1);
    const current = parseNumber(root.dataset.currentPage, 1);
    const maxVisible = parseNumber(
      root.dataset.maxVisible,
      MAX_VISIBLE_DEFAULT
    );
    return {
      totalPages: Math.max(1, total),
      currentPage: Math.min(Math.max(1, current), total),
      maxVisible: Math.max(1, maxVisible),
    };
  }

  function buildPageUrl(page) {
    const params = new URLSearchParams(window.location.search);
    params.set('page', String(page));
    return `${window.location.pathname}?${params.toString()}`;
  }

  function createPageItem(page, currentPage) {
    const li = document.createElement('li');
    const isActive = page === currentPage;

    li.innerHTML = `
      <button
        type="button"
        class="pagination__item${isActive ? ' pagination__item--active' : ''}"
        aria-label="Página ${page}"
        ${isActive ? 'aria-current="page"' : ''}
      >
        ${page}
      </button>
    `;

    const button = li.querySelector('button');
    button.onclick = () => navigate(page);
    return li;
  }

  function setPopupVisible(popup, visible, ellipsisBtn) {
    popup.setAttribute(ARIA.hidden, !visible);
    popup.hidden = !visible;
    if (ellipsisBtn) ellipsisBtn.setAttribute(ARIA.expanded, visible);
  }

  function hidePopup(popup, input, errorEl, ellipsisBtn) {
    setPopupVisible(popup, false, ellipsisBtn);
    input.value = '';
    input.setAttribute(ARIA.invalid, 'false');
    if (errorEl) errorEl.hidden = true;
  }

  function renderFullList(listEl, totalPages, currentPage) {
    for (let i = 1; i <= totalPages; i++) {
      listEl.appendChild(createPageItem(i, currentPage));
    }
  }

  function renderCompactList(
    root,
    listEl,
    { totalPages, currentPage, maxVisible }
  ) {
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      listEl.appendChild(createPageItem(i, currentPage));
    }

    if (end >= totalPages) {
      return null;
    }

    const ellipsisLi = document.createElement('li');
    ellipsisLi.className = 'pagination__ellipsis-wrap';

    ellipsisLi.innerHTML = `
      <button
        type="button"
        class="pagination__ellipsis"
        aria-label="Ir para página"
        ${ARIA.expanded}="false"
        aria-haspopup="dialog"
      >
        [...]
      </button>
    `;

    const ellipsisBtn = ellipsisLi.querySelector('button');

    const popup = root.querySelector(SEL.popup);
    if (popup) {
      ellipsisLi.appendChild(popup);
      setPopupVisible(popup, false, ellipsisBtn);
    }
    listEl.appendChild(ellipsisLi);
    listEl.appendChild(createPageItem(totalPages, currentPage));

    return ellipsisBtn;
  }

  function renderList(root, listEl, params) {
    const popup = root.querySelector(SEL.popup);
    if (popup && listEl.contains(popup)) {
      root.appendChild(popup);
    }

    listEl.innerHTML = '';
    const { totalPages, currentPage, maxVisible } = params;
    const useCompact = totalPages > maxVisible;

    if (useCompact) {
      return renderCompactList(root, listEl, params);
    }
    renderFullList(listEl, totalPages, currentPage);
    return null;
  }

  function setupArrow(root, selector, disabledWhen, targetPage) {
    const el = root.querySelector(selector);
    if (!el) return;
    el.disabled = disabledWhen;
    el.setAttribute(ARIA.disabled, disabledWhen);
    if (!disabledWhen) {
      el.onclick = () => navigate(targetPage);
    }
  }

  function updateArrows(root, currentPage, totalPages) {
    setupArrow(root, SEL.prev, currentPage <= 1, currentPage - 1);
    setupArrow(root, SEL.next, currentPage >= totalPages, currentPage + 1);
  }

  function getValidPage(inputValue, totalPages) {
    const num = parseInt(String(inputValue).trim(), 10);
    const valid = Number.isInteger(num) && num >= 1 && num <= totalPages;
    return { valid, page: valid ? num : null };
  }

  function setupPopup(root, ellipsisBtn, totalPages) {
    const popup = root.querySelector(SEL.popup);
    const input = root.querySelector(SEL.goInput);
    const btn = root.querySelector(SEL.goBtn);
    const errorEl = root.querySelector(SEL.goError);
    if (!popup || !input || !btn) return;

    input.setAttribute('max', String(totalPages));

    const maxLength = Math.min(
      parseNumber(input.dataset.maxLength, 5),
      String(totalPages).length
    );

    input.oninput = function () {
      if (this.value.length > maxLength) {
        this.value = this.value.slice(0, maxLength);
      }
    };

    const hide = () => hidePopup(popup, input, errorEl, ellipsisBtn);
    const show = () => {
      setPopupVisible(popup, true, ellipsisBtn);
      input.focus();
    };

    function validateAndGo() {
      const { valid, page } = getValidPage(input.value, totalPages);
      if (errorEl) {
        errorEl.hidden = valid;
        errorEl.textContent = valid
          ? ''
          : `Informe um número entre 1 e ${totalPages}.`;
      }
      input.setAttribute(ARIA.invalid, valid ? 'false' : 'true');
      if (valid) {
        hide();
        navigate(page);
      }
    }

    ellipsisBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = popup.getAttribute(ARIA.hidden) === 'false';
      isOpen ? hide() : show();
    });

    btn.onclick = (e) => {
      e.preventDefault();
      validateAndGo();
    };

    input.onkeydown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        validateAndGo();
        return;
      }
      if (e.key === 'Escape') {
        hide();
        ellipsisBtn?.focus();
      }
    };

    if (documentClickHandler) {
      document.removeEventListener('click', documentClickHandler);
    }
    documentClickHandler = (e) => {
      if (popup.getAttribute(ARIA.hidden) === 'true') return;
      if (!root.contains(e.target)) hide();
    };
    document.addEventListener('click', documentClickHandler);
  }

  function setupPerPageSelect(root) {
    const select = root.querySelector(SEL.perPage);
    if (!select) return;

    select.onchange = function () {
      const size = parseInt(this.value, 10);
      if (options.onSizeChange) {
        options.onSizeChange(size);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set('size', String(size));
        params.set('page', '1');
        window.location.href =
          window.location.pathname + '?' + params.toString();
      }
    };
  }

  function initPagination(root) {
    const listEl = root.querySelector(SEL.list);
    if (!listEl) return;

    const params = getPageParams(root);
    updateArrows(root, params.currentPage, params.totalPages);
    const ellipsisBtn = renderList(root, listEl, params);
    if (ellipsisBtn) setupPopup(root, ellipsisBtn, params.totalPages);
    setupPerPageSelect(root);
  }

  document.querySelectorAll(SEL.root).forEach(initPagination);

  if (options.onPageChange || options.onSizeChange) {
    document.querySelectorAll(SEL.root).forEach(function (root) {
      root.dataset.paginacaoManaged = 'true';
    });
  }

  return {
    update: function (totalPages, currentPage, currentSize) {
      document.querySelectorAll(SEL.root).forEach(function (root) {
        root.dataset.totalPages = String(Math.max(1, totalPages));
        root.dataset.currentPage = String(currentPage);

        if (currentSize != null) {
          const select = root.querySelector(SEL.perPage);
          if (select) select.value = String(currentSize);
        }

        initPagination(root);
      });
    },
  };
}
